module.exports = __webpack_public_path__ + "img/SSLRSMD.3e4769ed.svg";